<template>
  <div id="_participants">
    <div class="participants-container">
      <info-block :title="$getModuleTitle(currentEvent.modules, 'Participants')">
        <template slot="input">
          <div class="participant-header">
            <div class="participant-search">
              <el-input :placeholder="$t('search_in')" v-model="searchTerm" @clear="searchTerm = null" clearable></el-input>
            </div>
            <div class="participant-select">
              <el-select v-model="groupID" :placeholder="$t('filterGroupPlaceholder')" @clear="groupID = null" :no-data-text="$t('no_data_text')" clearable>
                <el-option v-for="item in currentGroups" :key="item.index" :label="item.title" :value="item.id">
                  <template>
                    <i class="fas fa-square" :style="'color:' + item.color" style="margin-right: 6px"></i>
                    <span>{{ item.title }}</span>
                  </template>
                </el-option>
              </el-select>
            </div>
          </div>
        </template>
      </info-block>
      <Nodata :title="$getModuleTitle(currentEvent.modules, 'Participants')" :description="subEventID == null && groupID == null && searchTerm == null && searchTerm != '' ? $t('contentNotFound') : $t('contentFilterNotFound')" anim="holacon-attendee-lottie" :loading="loading" v-if="participants.length == 0" :button="$t('refresh')" @btnClick="refresh()" />

      <div class="participants-list">
        <div class="participant-item" v-for="(item, index) in getList" :key="item.id + '-index-' + index">
          <div class="participant-avatar" @click="$root.$emit('getProfile', item.id)" :style="(item.group != null ? 'border-color:' + item.group.color + '!important;' : '') + 'background-image: url(' + $imageus + item.image + '?width=150&height=150&mode=cover);'"></div>
          <div class="participant-title" @click="$root.$emit('getProfile', item.id)">
            <p>
              {{ item.fullName }}
              <strong v-if="item.title != null">@{{ item.title }}</strong>
            </p>
            <p>{{ item.group.title }}</p>
          </div>
          <div class="participant-operations">
            <el-button
              v-if="showInvite"
              type="primary"
              round
              size="mini"
              @click="
                $root.$emit('network-request', item.id);
                $root.$emit('closeNetworkRequestModal');
              "
            >
              <i class="fas fa-paper-plane"></i>
              {{ $t("sendInvite") }}
            </el-button>
          </div>
        </div>
      </div>

      <infinite-loading :identifier="participantIdentifier" :key="participantIdentifier" @infinite="getData">
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";
import InfoBlock from "../modules/InfoBlock.vue";
export default {
  name: "ParticipantsComponent",
  components: { InfiniteLoading, InfoBlock },
  props: ["showInvite", "loadDataMounted", "subEventID"],
  data() {
    return {
      participants: [],
      timeout: null,
      searchTerm: null,
      loading: false,
      groupID: null,
      participantIdentifier: +new Date()
    };
  },

  methods: {
    async getData($state) {
      try {
        axios.defaults.headers["eventID"] = this.currentEvent.id;
        var response = await axios.post("/Participant/GetParticipants", {
          skip: this.participants.length,
          take: 20,
          searchTerm: this.searchTerm != "" ? this.searchTerm : null,
          groupID: this.groupID != null ? this.groupID : null
        });
        this.participants.push(...response.data.data.items);
        this.loading = false;
        if (response.data.data.items.length == 0) $state.complete();
        else $state.loaded();
      } catch (err) {
        console.log("participants catch err - ", err);
      }
    },
    refresh() {
      this.loading = true;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.searchTerm = null;
        this.groupID = null;
        this.participantIdentifier++;
        this.loading = false;
      }, 500);
    }
  },

  async mounted() {
    await this.$store.dispatch("getGroups", { id: this.currentEvent.id, route: false });
    setTimeout(() => {
      this.participantIdentifier += 1;
    }, 500);
  },

  computed: {
    getList() {
     return this.participants;
    },
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    currentGroups() {
      return this.$store.getters.getGroups;
    }
  },

  watch: {
    searchTerm: function() {
      this.loading = true;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.participants = [];
        this.participantIdentifier++;
        this.loading = false;
      }, 500);
    },
    groupID: function() {
      this.loading = true;
      clearTimeout(this.timeout);
      this.timeout = null;
      this.participants = [];
      this.participantIdentifier += 1;
    }
  }
};
</script>

<style lang="less">
#_participants {
  display: flex;
  flex-direction: column;
  width: 100%;

  .participants-container {
    display: block;
    width: inherit;
    margin: 0 auto;

    .participant-header {
      display: grid;
      grid-template-columns: 2fr 1fr;
      grid-gap: 10px;
      width: 100%;

      .participant-search {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        position: relative;
      }

      .participant-select {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        position: relative;
      }
    }

    .participants-list {
      width: 100%;

      .participant-item {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        background-color: white;
        box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
        border-radius: 12px;
        padding: 6px 12px;
        margin-bottom: 10px;

        &:hover {
          background-color: #fbfbfb;
          transition: all 0.3s ease 0s;
        }

        .participant-avatar {
          width: 45px;
          height: 45px;
          aspect-ratio: 1;
          background-size: cover;
          border-radius: 50%;
          border: 4px solid #f1f1f1;
          cursor: pointer;
        }

        .participant-title {
          margin-left: 12px;
          width: ~"calc(100% - 110px)";
          cursor: pointer;

          p {
            margin: 0px;
            padding: 0px;
            font-weight: 400;
            color: #292f3b;
            font-size: 16px;

            &:last-child {
              color: #8c929c;
              font-size: 13px;
            }

            strong {
              font-weight: 600;
            }
          }
        }

        .participant-operations {
          display: block;

          .invite-button {
            box-shadow: unset;

            i {
              color: #8c929c;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  #_participants {
    padding: 0px;

    .participants-container {
      padding: 0px 12px;

      .participant-header {
        grid-template-columns: 1fr !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/Participants.vue